export const DATA = [
	{
		id: '1',
		label: 'Home',
		link: '/',
	},
	{
		id: '2',
		label: 'About',
		link: '/about',
	},
	{
		id: '3',
		label: 'Test',
		link: '/test',
		source: 'https://github.com/paulho1973/random-graph-pwa/tree/master/src/Test',
	},
	{
		id: '4',
		label: 'QR Code Scanner',
		link: '/qrscan',
		source: 'https://github.com/paulho1973/random-graph-pwa/tree/master/src/Qrscan',
	},
	{
		id: '5',
		label: 'QR Price Tag',
		link: '/pricetag',
		source: 'https://github.com/paulho1973/random-graph-pwa/tree/master/src/PriceTag',
	},
	{
		id: '6',
		label: 'eWallet',
		link: '/ewallet',
		source: 'https://github.com/paulho1973/random-graph-pwa/tree/master/src/EWallet',
	},
	{
		id: '7',
		label: 'QR Code Reader',
		link: '/qrreader',
		source: 'https://github.com/paulho1973/random-graph-pwa/tree/master/src/QrReader',
	},
];
